import React from 'react';
import { BG, KANT, RADIUS } from '../komponenter/index';

/**
 * Delt Boks-komponent til OS-paneler.
 * @param {number} blur - backdrop blur i px (default 16)
 * @param {string} padding - CSS padding (default '18px 20px')
 * @param {object} style - ekstra styles
 */
export function Boks({ children, blur = 16, padding = '18px 20px', style, ...rest }) {
  return (
    <div
      style={{
        background: BG.kort,
        border: `1px solid ${KANT.standard}`,
        borderRadius: RADIUS.kort,
        backdropFilter: `blur(${blur}px)`,
        WebkitBackdropFilter: `blur(${blur}px)`,
        padding,
        ...style,
      }}
      {...rest}
    >
      {children}
    </div>
  );
}
